import { ChartType } from './chart-type';

export const splineChartOptions = {
  series: [
    {
      lineWidth: 1,
      marker: {
        enabled: false,
      },
      states: {
        hover: {
          marker: {
            enabled: false,
          },
        },
      },
      type: ChartType.SPLINE,
    },
  ],
};
